import type { ReactNode } from "react";
import { VaffaMark } from "./VaffaMark";

export function VoiceHero({ children }: { children: ReactNode }) {
  return (
    <section className="voice-hero" aria-labelledby="voice-hero-title">
      <div className="voice-hero__mark" aria-hidden="true">
        <VaffaMark />
        <span className="voice-hero__echo voice-hero__echo--one" />
        <span className="voice-hero__echo voice-hero__echo--two" />
      </div>

      <h1 id="voice-hero-title">
        Dillo forte.
        <span>Senza dirlo male.</span>
      </h1>
      <p>Racconta il fastidio. Noi lo trasformiamo in un vocale breve.</p>
      {children}
    </section>
  );
}
